module.exports = __webpack_public_path__ + "static/media/cvo-tri-glide-charred-crimson.59142c69.png";